import { SliderType } from './SliderType';

export interface SliderSlide {
  id: number;
  path: string;
  url?: string;
  locale?: string;
  type: SliderType;
}

export const sliderSlideFromResponse = (responseData: any): SliderSlide => ({
  id: responseData.id,
  path: responseData.path,
  url: responseData.url,
  locale: responseData.locale,
  type: responseData.type,
});

export const sliderSlideToUpdateRequest = (sliderSlide: SliderSlide) => ({
  url: sliderSlide.url,
  locale: sliderSlide.locale,
  type: sliderSlide.type,
});
